module.exports = __webpack_public_path__ + "img/suzy.4f735224.jpg";